import { NavLink } from 'react-router-dom';
import c from 'classnames';

import { LinkButton, ButtonVariants, NewUpdateDot } from 'components';

import { Icon, IconName, Typography } from '@repo/ui';
import styles from './Sidebar.module.css';

const SidebarItem = ({
  to,
  icon,
  label,
  onClick,
  state,
  external,
  customClassName,
  showDot = false,
}: {
  to: string;
  icon: IconName;
  label: string;
  onClick?: () => void;
  state?: {
    tinyAccountId?: string;
    kitId?: string;
    from?: string;
    analyticsSource?: string;
  };
  external?: boolean;
  customClassName?: string;
  showDot?: boolean;
}) => {
  if (external) {
    return (
      <LinkButton
        label={label}
        href={to}
        external
        onClick={onClick}
        variant={ButtonVariants.WRAPPER}
        linkClassName={c(
          styles.sidebarItem,
          'align-items-center',
          customClassName,
        )}
      >
        <span className={styles.sidebarItemIconWrap}>
          <Icon name={icon} />
          <NewUpdateDot show={showDot} className={styles.sidebarItemDot} />
        </span>
        <Typography variant='body-s'>{label}</Typography>
      </LinkButton>
    );
  }

  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        c(
          styles.sidebarItem,
          'align-items-center',
          isActive && styles.active,
          customClassName,
        )
      }
      onClick={onClick}
      state={{ ...state }}
    >
      {({ isActive }) => (
        <>
          <span className={styles.sidebarItemIconWrap}>
            <Icon name={isActive ? ((icon + 'Filled') as IconName) : icon} />
            <NewUpdateDot show={showDot} className={styles.sidebarItemDot} />
          </span>
          <Typography variant='body-s'>{label}</Typography>
        </>
      )}
    </NavLink>
  );
};

export default SidebarItem;
